import { render, staticRenderFns } from "./RecomendForm.vue?vue&type=template&id=2833bdae&scoped=true&"
import script from "./RecomendForm.vue?vue&type=script&lang=js&"
export * from "./RecomendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2833bdae",
  null
  
)

export default component.exports